module.exports = __webpack_public_path__ + "img/feeback-alert.b4698013.svg";